<div class="modal fade dirI" id="carCluster" tabindex="-1" aria-labelledby="dashboardClusterDetailsTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content" *ngIf="vehicle">
            <div class="modal-header">
                <h5 class="modal-title" id="dashboardClusterDetailsTitle">{{vehicle.strFullName}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="بستن"></button>
            </div>
            <div class="modal-body d-flex justify-content-around flex-wrap">
                <div class="col-5" *ngIf="vehicle.strDate">
                    <p class="text-secondary dirI"> <span class="bold">آخرین زمان موقعیت</span> :
                        {{vehicle.strDate}}-{{vehicle.strTime}}
                    </p>
                </div>
                <div class="col-5" *ngIf="vehicle.strMobile">
                    <p class="text-secondary"> <span class="bold">موبایل</span> : {{vehicle.strMobile}}</p>
                </div>
                <div class="col-5" *ngIf="vehicle.strMobileType_strComment">
                    <p class="text-secondary"> <span class="bold">گروه خودرو</span> :
                        {{vehicle.strMobileType_strComment}}
                    </p>
                </div>
                <div class="col-5" *ngIf="vehicle.strVehicleNo">
                    <p class="text-secondary"><span class="bold">پلاک</span> : {{vehicle.strVehicleNo}}</p>
                </div>
                <div class="col-5 " *ngIf="vehicle.strJournalType_strComment">
                    <p class="text-secondary"><span class="bold">تخلف</span> :
                        {{vehicle.strJournalType_strComment}}</p>
                </div>
                <div class="col-5" *ngIf="vehicle.tiMaxSpeed">
                    <p class="text-secondary"><span class="bold">حداکثر سرعت مجاز</span> : {{vehicle.tiMaxSpeed}}
                    </p>
                </div>
                <div class="col-5" *ngIf="vehicle.strComment">
                    <p class="text-secondary"><span class="bold">توضیحات</span> : {{vehicle.strComment}}</p>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>
            </div>
        </div>
    </div>
</div>
